import React from 'react'
import { observable } from 'mobx'

const CollectionContext = React.createContext(observable([]))

export const Provider = CollectionContext.Provider
export const Consumer = CollectionContext.Consumer

export default CollectionContext
